import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import {Table} from 'react-bootstrap';
import AddCuisine from './AddCuisine';

import {getCuisineDetailsById} from '../../../services/FoodItemsService';

const CuisineList = props => {
    const {cuisineList, getCuisineList} = props;
    const [addNewModal, setAddNewModal] = useState(false);
    const [cuisineId, setCuisineId] = useState();
    const [cuisineDetails, setCuisineDetails] = useState();

    useEffect(() => {
        getCuisineList();
    }, [getCuisineList]);

    useEffect(() => {
        if (!addNewModal) {
            setCuisineDetails();
            setCuisineId();
            getCuisineList();
        }
    }, [addNewModal, getCuisineList]);

    useEffect(() => {
        console.log(cuisineList);
    }, [cuisineList]);

    const editData = id => {
        setAddNewModal(true);
        setCuisineId(id);
        getCuisineDetailsById(id).then(res => {
            setCuisineDetails(res);
        });
    };

    const addData = id => {
        setAddNewModal(true);
    };

    return (
        <>
            <ToastContainer
                position='top-center'
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className='col-xl-12'>
                <div className='card'>
                    <div className='card-header d-flex justify-content-end'>
                        <div>
                            <Link
                                className='btn btn-primary font-w600 mb-2 mr-auto'
                                to='#'
                                onClick={() => addData()}
                            >
                                + New Cuisine
                            </Link>
                        </div>
                    </div>
                    <div className='card-body p-0'>
                        <div className='table-responsive order-list card-table'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>
                                            <strong></strong>
                                        </th>
                                        <th>
                                            <strong>NAME</strong>
                                        </th>
                                        <th>
                                            <strong>ARABIC NAME</strong>
                                        </th>
                                        <th>
                                            <strong>NO. OF FOOD ITEMS</strong>
                                        </th>
                                        <th>
                                            <strong>STATUS</strong>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cuisineList?.length ? (
                                        cuisineList.map(cuisine => (
                                            <tr key={cuisine.id}>
                                                <td>
                                                    <img
                                                        src={
                                                            process.env
                                                                .REACT_APP_API_RESOURCE_URL +
                                                            cuisine.img
                                                        }
                                                        className='rounded-lg mr-2'
                                                        width='54'
                                                        alt=''
                                                    />
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <span className='w-space-no'>
                                                            {cuisine.name}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <span className='w-space-no'>
                                                            {cuisine.name_arb}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <span className='w-space-no'>
                                                            {
                                                                cuisine.no_of_fooditems
                                                            }
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <i
                                                            className={`fa fa-circle ${
                                                                cuisine.status
                                                                    ? 'text-success'
                                                                    : 'text-danger'
                                                            } mr-1`}
                                                        ></i>{' '}
                                                        {cuisine.status
                                                            ? 'Active'
                                                            : 'Inactive'}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='d-flex'>
                                                        <div
                                                            onClick={() =>
                                                                editData(
                                                                    cuisine.id
                                                                )
                                                            }
                                                            className='btn btn-primary shadow btn-xs sharp mr-1'
                                                        >
                                                            <i className='fa fa-pencil'></i>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td>
                                                <div id='preloader-inner'>
                                                    <div className='sk-three-bounce-inner'>
                                                        <div className='sk-child sk-bounce1'></div>
                                                        <div className='sk-child sk-bounce2'></div>
                                                        <div className='sk-child sk-bounce3'></div>
                                                        <div id='preloader-inner-bg'></div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
                {/* add new food item */}
                {addNewModal ? (
                    <AddCuisine
                        addNewModal={addNewModal}
                        setAddNewModal={setAddNewModal}
                        cuisineDetails={cuisineDetails}
                        setCuisineDetails={setCuisineDetails}
                        cuisineId={cuisineId}
                    />
                ) : (
                    ''
                )}
            </div>
        </>
    );
};

export default CuisineList;
